/**
 * SSL certs page (legacy ssl-ev) — migrated from public/js/ssl-ev.js.
 *
 * Fetch XML cu certificate, populeaza submenu pe baza autoritati, populeaza
 * spec card + pricing cards la click. Plus form de request.
 */
import { Resort } from '../core/resort.js';

interface CertInfo {
    period:    string;
    aut_price: string;
    nav_price: string;
    order_url: string;
}
interface CertGroup {
    name:           string;
    algorithm:      string;
    dom_secured:    string;
    green_bar:      string;
    trust_seal:     string;
    search_engine:  string;
    srv_licenses:   string;
    mobile_support: string;
    ssl_reissuance: string;
    validation_type:string;
    csr_encryption: string;
    browser_comp:   string;
    warranty:       string;
    issuance_time:  string;
    ssl_encryption: string;
    cl_comp:        string;
    refund_policy:  string;
    cert:           CertInfo[];
}

new Resort((rt) => {
    /* Inputs focus/blur */
    $('input[type="text"], textarea', true).on('focus', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p && !p.classList.contains('lb-focused')) p.classList.add('lb-focused');
    });
    $('input[type="text"], textarea', true).on('blur', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p?.classList.contains('lb-focused')) p.classList.remove('lb-focused');
    });

    /* Fetch + parse SSL certs XML */
    fetch(`/res/ssl-certs.xml?${Date.now()}`, { method: 'get', cache: 'no-cache' })
        .then((r) => r.text())
        .then((res) => {
            const xml = new DOMParser().parseFromString(res, 'text/xml');
            const nav = xml.find('nav') as Element | null;
            if (!nav) return;

            const certs: Record<string, CertGroup[]> = {};
            const currency = (nav.find('currency') as Element | null)?.textContent ?? '';

            nav.find('authority', (auth: Element) => {
                const name = auth.getAttribute('name') ?? '';
                certs[name] = [];

                auth.find('certs', (crts: Element) => {
                    const cert: CertInfo[] = [];
                    crts.find('cert', (crt: Element) => {
                        cert.push({
                            period:    crt.getAttribute('period') ?? '',
                            aut_price: (crt.find('aut_price') as Element | null)?.textContent ?? '',
                            nav_price: (crt.find('nav_price') as Element | null)?.textContent ?? '',
                            order_url: (crt.find('order_url') as Element | null)?.textContent ?? '',
                        });
                        return true;
                    });
                    const getText = (sel: string) => (crts.find(sel) as Element | null)?.text() ?? '';
                    certs[name]!.push({
                        name:            crts.getAttribute('name') ?? '',
                        algorithm:       getText('algorithm') as string,
                        dom_secured:     getText('dom_secured') as string,
                        green_bar:       getText('green_bar') as string,
                        trust_seal:      getText('trust_seal') as string,
                        search_engine:   getText('search_engine') as string,
                        srv_licenses:    getText('srv_licenses') as string,
                        mobile_support:  getText('mobile_support') as string,
                        ssl_reissuance:  getText('ssl_reissuance') as string,
                        validation_type: getText('validation_type') as string,
                        csr_encryption:  getText('csr_encryption') as string,
                        browser_comp:    getText('browser_comp') as string,
                        warranty:        getText('warranty') as string,
                        issuance_time:   getText('issuance_time') as string,
                        ssl_encryption:  getText('ssl_encryption') as string,
                        cl_comp:         getText('cl_comp') as string,
                        refund_policy:   getText('refund_policy') as string,
                        cert,
                    });
                    return true;
                });
                return true;
            });

            let cert: CertGroup[] = [];
            let current: string | null = null;
            let index = 0;
            const spec = $('.layer-3 .spec') as Element | null;

            ($('.ssl-menu') as Element | null)?.on('click', 'a', function (this: Element) {
                if (this.classList.contains('active')) return;
                ($('.ssl-menu a.active') as Element | null)?.classList.remove('active');
                this.classList.add('active');

                current = (this as HTMLElement).dataset['name'] ?? '';
                index = this.index($('.ssl-menu a', true) as unknown as NodeListOf<Element>);
                const list = certs[current] ?? [];

                const submenu = $('ul.ssl-submenu') as Element | null;
                submenu?.html('');
                cert = [];
                for (const item of list) {
                    const li = $(`<li><a>${item.name}</a></li>`) as Element | null;
                    if (li) submenu?.append(li);
                    cert.push(item);
                }
                ($('ul.ssl-submenu a', true) as NodeListOf<Element>).item(0)?.dispatchEvent(new Event('click'));
            });

            ($('ul.ssl-submenu') as Element | null)?.on('click', 'a', function (this: Element) {
                if (this.classList.contains('active') || !cert.length) return;
                ($('ul.ssl-submenu a.active') as Element | null)?.classList.remove('active');
                this.classList.add('active');

                const submenuItems = $('ul.ssl-submenu a', true) as NodeListOf<Element>;
                const selected = cert[this.index(submenuItems)];
                if (!selected) return;

                window.each(selected as unknown as Record<string, unknown>, (label: unknown, key: string) => {
                    if (key === 'name' || key === 'cert') return;
                    (spec?.find(`p[data-id="${key}"]`) as Element | null)?.text(String(label));
                });

                $('.layer-2 .col', (that: Element, i?: unknown) => {
                    const idx = (i as number) ?? 0;
                    if (idx === 0) {
                        const icon = that.find('.icon') as HTMLElement | null;
                        if (icon) {
                            icon.className = '';
                            icon.classList.add('spr', 'icon', `icon-${index + 1}`);
                        }
                        return true;
                    }
                    const crt = selected.cert[idx - 1];
                    if (!crt) return true;
                    const per = crt.period.split(' ');
                    (that.find('h3') as HTMLElement | null)?.html(`<strong>${per[0]}</strong> ${per[1] ?? ''}`);
                    (that.find('p.real-price') as HTMLElement | null)?.text(`${crt.aut_price} ${currency}`);
                    (that.find('strong.aut') as HTMLElement | null)?.text(current ?? '');
                    (that.find('p.nav-price') as HTMLElement | null)?.text(`${crt.nav_price} ${currency}`);
                    (that.find('p.save') as HTMLElement | null)?.text(`${parseFloat(crt.aut_price) - parseFloat(crt.nav_price)} ${currency}`);
                    (that.find('a.btn-order') as HTMLElement | null)?.setAttribute('href', crt.order_url);
                    return true;
                });
            });

            ($('.ssl-menu a', true) as NodeListOf<Element>).item(0)?.dispatchEvent(new Event('click'));
        })
        .catch((e) => { if (import.meta.env.DEV) console.error('[ssl-ev]', e); });

    /* Request form */
    const is_en = /\/en\//.test(window.location.href);
    const rForm = $('#request-form') as HTMLFormElement | null;
    rForm?.Form('form', 'certs_send_request', {}, {
        valid: () => ({
            company: 'min(5)max(40)',
            name:    'min(5)max(40)',
            email:   'mail(40)',
            phone:   'min(10)max(30)',
            message: 'nn()max(10000)',
        }),
        done: (r: unknown) => {
            if (r === 'Done') {
                rt.notify(is_en ? 'Your message was sent successfully.' : 'Mesajul tău a fost expediat cu succes.');
                rForm?.reset();
            }
        },
    });
});
